// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnitsStats__wrapper___1Yu-s","col":"UnitsStats__col___K7tx_","field":"UnitsStats__field___1bEDD","label":"UnitsStats__label___2GLpQ","value":"UnitsStats__value___30wSJ"};